import { FormControlOptions, Section } from '@miq/catalog';
import { EntityType } from '@shared/models/entity-enum';
import { AvailabilityFormConfig } from './availability-form.config';
import { BrandFormConfig } from './brand-form.config';
import { CompanyFormConfig } from './company-form.config';
import { ContactFormConfig } from './contact-form.config';
import { LeaseSaleFormConfig } from './lease-sale-form.config';
import { PortfolioSaleFormConfig } from './portfolio-sale-form.config';
import { PropertyFormConfig } from './property-form.config';
import { TenancyFormConfig } from './tenancy-form.config';
import { TimFormConfig } from './tim-form.config';

/** Immutable object with form configs by entity */
const formConfigs = Object.freeze({
  [EntityType.Property]: PropertyFormConfig,
  [EntityType.LeaseComp]: LeaseSaleFormConfig,
  [EntityType.SaleComp]: LeaseSaleFormConfig,
  [EntityType.Company]: CompanyFormConfig,
  [EntityType.Availability]: AvailabilityFormConfig,
  [EntityType.Tim]: TimFormConfig,
  [EntityType.Brand]: BrandFormConfig,
  [EntityType.Tenancy]: TenancyFormConfig,
  [EntityType.PortfolioSale]: PortfolioSaleFormConfig,
  [EntityType.Contact]: ContactFormConfig,
});

/**
 * Helper function to get entity form control configs by entity
 */
export function getFormConfigByType(entity: EntityType): { [key: string]: FormControlOptions<Section> } {
  return {
    // add MIQ virtual attributes (not edp stored)
    miqProperties: {
      name: 'miqProperties',
      type: 'control',
    },
    access_control: {
      name: 'access_control',
      type: 'group',
      controlsConfig: {
        privacy_effective_date: [null],
        privacy_expiration_date: [null],
        privacy_reason: [null],
        privacy_reason_type_desc: [null],
        private_data_f: [null],
        teams: [[]],
        users: [[]],
      },
    },
    ...formConfigs[entity],
  };
}
